import React, { Component } from 'react'
import PropTypes from 'prop-types'
import Row from 'component/utils/Row'
import Col from 'component/utils/Col'
import Form from 'component/gama/Form'
import EnableInput from 'component/gama/EnableInput'
import GamaFormSection from 'component/gama/GamaFormSection'
import AccordionGama from 'component/gama/AccordionGama'
import Field from 'component/utils/Field'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelect'
import { CustomMenuList as MenuList } from 'component/reactSelect/CustomMenuList'
import { CustomMultiValue as MultiValueContainer } from 'component/reactSelect/CustomMultiValue'

import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import moment from 'moment'
import LabelInputValid from '../utils/LabelInputValid'

const ALL = 'all'

class GamaForm extends Component {
  state = {
    gamaSecModels: [],
  }

  async componentDidMount() {
    // Get sections
    const sections = await this.getSections()

    if (sections.status) {
      await sections.data.map((sec) => {
        sec.inAll = false
      })

      this.setState({
        gamaSecModels: sections.data,
        gamaSecParams: {},
        loading: false,
        error: null,
      })
    } else {
      this.setState({
        gamaSecModels: [],
        loading: false,
        error: sections.error,
      })
    }

    this.populateGama(this.props.savedGama)
  }

  async componentWillReceiveProps(nextProps) {
    const { savedGama } = this.props

    if (nextProps.savedGama !== savedGama) {
      this.fillForm(nextProps)

      this.setState({
        savedGama: nextProps.savedGama,
      })

      const sections = await this.getSections()

      if (sections.status) {
        await sections.data.map((sec) => {
          sec.inAll = false
        })

        this.setState({
          gamaSecModels: sections.data,
          gamaSecParams: {},
          loading: false,
          error: null,
        })
      } else {
        this.setState({
          gamaSecModels: [],
          loading: false,
          error: sections.error,
        })
      }
    }
  }

  fillForm = (nextProps) => {
    const { setValueToField } = this.props

    setValueToField('nrItmDaySec', nextProps.savedGama.nrItmDaySec)
    setValueToField('inItmWtSl', nextProps.savedGama.inItmWtSl)
    setValueToField('inItmWtotSl', nextProps.savedGama.inItmWtotSl)
    setValueToField('inItmHighRisk', nextProps.savedGama.inItmHighRisk)
    setValueToField('inItmNegStck', nextProps.savedGama.inItmNegStck)
    setValueToField('inItmInAVs', nextProps.savedGama.inItmInAVs)
    setValueToField('nrItmWtSl', nextProps.savedGama.nrItmWtSl)
    setValueToField('nrItmWtotSl', nextProps.savedGama.nrItmWtotSl)
    setValueToField('nrItmHighRisk', nextProps.savedGama.nrItmHighRisk)
    setValueToField('nrItmNegStck', nextProps.savedGama.nrItmNegStck)
    setValueToField('nrItmInAvs', nextProps.savedGama.nrItmInAvs)
    setValueToField('nrDayItmWtSl', nextProps.savedGama.nrDayItmWtSl)
    setValueToField('nrDayItmWtotSl', nextProps.savedGama.nrDayItmWtotSl)
    setValueToField('inTopOne', nextProps.savedGama.inTopOne)
    setValueToField('inTopTwo', nextProps.savedGama.inTopTwo)
    setValueToField('inTopThree', nextProps.savedGama.inTopThree)
    setValueToField('nrRepeatDay', nextProps.savedGama.nrRepeatDay)
    setValueToField('nrJtDiff', nextProps.savedGama.nrJtDiff)
    setValueToField('nrJtDiffRl', nextProps.savedGama.nrJtDiffRl)
    setValueToField('nrItmStckLess', nextProps.savedGama.nrItmStckLess)
    setValueToField('nrItmLrgrStck', nextProps.savedGama.nrItmLrgrStck)
    setValueToField('nrMinVlrStck', nextProps.savedGama.nrMinVlrStck)
    setValueToField('nrItmInTop2500', nextProps.savedGama.nrItmInTop2500)
    setValueToField('inItmInTop2500', nextProps.savedGama.inItmInTop2500)
  }

  async clearForm() {
    const { setValueToField } = this.props

    setValueToField('nrItmDaySec', '')
    setValueToField('inItmWtSl', '')
    setValueToField('inItmWtotSl', '')
    setValueToField('inItmHighRisk', '')
    setValueToField('inItmNegStck', '')
    setValueToField('inItmInAVs', '')
    setValueToField('nrItmWtSl', '')
    setValueToField('nrItmWtotSl', '')
    setValueToField('nrItmHighRisk', '')
    setValueToField('nrItmNegStck', '')
    setValueToField('nrItmInAvs', '')
    setValueToField('nrDayItmWtSl', '')
    setValueToField('nrDayItmWtotSl', '')
    setValueToField('inTopOne', '')
    setValueToField('inTopTwo', '')
    setValueToField('inTopThree', '')
    setValueToField('nrRepeatDay', '')
    setValueToField('nrJtDiff', '')
    setValueToField('nrJtDiffRl', '')
    setValueToField('nrItmStckLess', '')
    setValueToField('nrItmLrgrStck', '')
    setValueToField('nrMinVlrStck', '')
    setValueToField('nrItmInTop2500', '')
    setValueToField('inItmInTop2500', '')

    const sections = await this.getSections()

    if (sections.status) {
      await sections.data.map((sec) => {
        sec.inAll = false
      })

      this.setState({
        savedGama: {},
        gamaSecModels: sections.data,
        gamaSecParams: {},
        loading: false,
        error: null,
      })
    } else {
      this.setState({
        savedGama: {},
        gamaSecModels: [],
        loading: false,
        error: sections.error,
      })
    }
  }

  getSections = () => {
    const params = {
      level: 2,
      sectionId: 0,
      subSectionId: 0,
      typeId: 0,
      subTypeId: 0,
      limit: 50,
      offset: 0,
    }

    return this.fetchData(params)
  }

  fetchData = async (params) => {
    const {
      auth: { user },
    } = this.props
    /* istanbul ignore else */
    if (user) {
      this.setState({ loading: true })

      try {
        const { data } = await new Api(user.dsToken).post(
          API_URL.SECTIONS_HIERARCHY,
          params
        )

        return { status: true, data }
      } catch (error) {
        return { status: false, error }
      }
    }
  }

  populateGama = (savedGama) => {
    this.setState({ savedGama })
  }

  cleanFieldNumber = (disabled, fieldNumber) => {
    /* istanbul ignore else */
    if (disabled) {
      const { setValueToField } = this.props
      setValueToField(fieldNumber.input.name, '')
    }
  }

  handleSubmit = (event) => {
    event.preventDefault()
    const { values, onSubmit } = this.props
    const { gamaSecModels } = this.selectChange.state

    const reduce = gamaSecModels.reduce(
      (acc, cur) => {
        /* istanbul ignore else */
        acc[0] = [
          ...acc[0],
          {
            sectionId: cur.sectionId,
            inAll: cur.inAll ? 1 : 0,
            description: cur.description,
          },
        ]

        if (cur.subSecOptions && cur.subSecOptions.selectedOptions) {
          acc[1] = [...acc[1], ...cur.subSecOptions.selectedOptions]
        }
        if (cur.typeOptions && cur.typeOptions.selectedOptions) {
          acc[2] = [...acc[2], ...cur.typeOptions.selectedOptions]
        }
        if (cur.subTypeOptions && cur.subTypeOptions.selectedOptions) {
          acc[3] = [...acc[3], ...cur.subTypeOptions.selectedOptions]
        }
        return acc
      },
      [[], [], [], []]
    )

    const ins = Object.keys(values).reduce((acc, cur) => {
      if (cur.startsWith('in')) {
        acc[cur] = values[cur] ? 1 : 0
      }
      if (cur.startsWith('nr')) {
        let aux = ''
        aux = !!values[cur] && values[cur].toString().replace('%', '')
        if (aux) {
          acc[cur] = aux.replace(',', '.')
        } else {
          acc[cur] = ''
        }
      }
      return acc
    }, [])

    const selectedBranches = values.listRegionsAndBranchs || []

    const gamaRegionsBranchsParams = []

    for (const option of selectedBranches) {
      if (option.value !== ALL) {
        const gamaRegionsBranchsParam = {
          idGama: null,
          branchRegion: option.value,
          dsBranchRegion: option.label,
          inRegion: option.isBranch === undefined ? 1 : 0,
        }

        gamaRegionsBranchsParams.push(gamaRegionsBranchsParam)
      }
    }

    const param = {
      ...values,
      ...ins,
      gamaSecParams: reduce[0],
      gamaSubSecParams: reduce[1],
      gamaTypeParams: reduce[2],
      gamaSubTypeParams: reduce[3],
      gamaRegionsBranchsParams,
      dsYear: moment().year(),
    }

    onSubmit(param)
  }

  branchChange = async (selectedOption, input) => {
    const { auth, fetchSections, setValueToField } = this.props

    input.value = selectedOption
    const event = { target: input }
    input.onChange(event)
    setValueToField('listRegionsAndBranchs', selectedOption)

    if (
      selectedOption.length === 1 &&
      selectedOption[0].value !== ALL &&
      selectedOption[0].isBranch !== undefined
    ) {
      const params = {
        level: 2,
        sectionId: 0,
        subSectionId: 0,
        typeId: 0,
        subTypeId: 0,
        limit: 50,
        offset: 0,
        gamaRegionsBranchsParams: [
          {
            idGama: null,
            branchRegion: selectedOption[0].value,
            dsBranchRegion: selectedOption[0].label,
            inRegion: 0,
          },
        ],
      }

      await fetchSections(auth.user.dsToken, params).then(() => {
        this.setState({ loadedGama: true })
      })
    } else {
      this.clearForm()
    }
  }

  render() {
    const {
      translate,
      auth: { user },
    } = this.props

    const field = this.props.fields

    const { gamaSecModels = [], savedGama } = this.state

    const children = {
      title: translate('irc.gama.select.placeholder'),
      content: (
        <GamaFormSection
          gamaSecModels={gamaSecModels}
          savedGama={savedGama}
          translate={translate}
          user={user}
          ref={(c) => {
            this.selectChange = c
          }}
        />
      ),
    }

    return (
      <Col md={10} mdOffset={1}>
        <h4 className='margin-bottom'>{translate('irc.gama.criteria')}</h4>
        <form className='GamaForm'>
          <fieldset>
            <Row>
              <div className='margin-bottom margin-left-small margin-right-small'>
                <Field
                  {...field.listRegionsAndBranchs}
                  hint={translate('irc.choose-store')}
                >
                  <RegionBranchMultipleSelect
                    id='listRegionsAndBranchs'
                    {...field.listRegionsAndBranchs.input}
                    placeholder=''
                    components={{ MenuList, MultiValueContainer }}
                    className='react-select-collapsible'
                    translate={translate}
                    onChange={(event) =>
                      this.branchChange(
                        event.target.value,
                        field.listRegionsAndBranchs.input
                      )
                    }
                    allOption
                    excludeInactive={true}
                  />
                </Field>
              </div>
            </Row>
            <Row>
              <Col xs={12}>
                <AccordionGama className='accordion-gama-item'>
                  {children}
                </AccordionGama>
              </Col>
            </Row>
            <Row className='input-section'>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  disabledHelper
                  validate
                  {...field.nrItmDaySec}
                  error={translate(field.nrItmDaySec.error)}
                  id={'qtdeItemPerDaysPerSection'}
                  name={field.nrItmDaySec}
                  labelLeft={translate('irc.gama.labelItemQtyDaySection')}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'notRepeatPerDays'}
                  name={field.nrRepeatDay}
                  labelLeft={translate('irc.gama.labelDontRepeatLM')}
                  labelRight={translate('irc.gama.labelDays')}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'justificationPerDifference'}
                  name={field.nrJtDiff}
                  labelLeft={translate('irc.gama.labelJustificationDifference')}
                  labelRight={translate(
                    'irc.gama.labelJustificationDifferencePercentage'
                  )}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'justificationPerRealDifference'}
                  name={field.nrJtDiffRl}
                  labelLeft={translate(
                    'irc.gama.justificationPerRealDifference'
                  )}
                  labelRight={translate(
                    'irc.gama.labeljustificationPerRealDifference'
                  )}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'itemStockLess'}
                  name={field.nrItmStckLess}
                  labelLeft={translate('irc.gama.labelItemWithLowerStock')}
                  labelRight={translate(
                    'irc.gama.labelItemWithHighterStock.unit'
                  )}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'nrItmLrgrStck'}
                  name={field.nrItmLrgrStck}
                  labelLeft={translate('irc.gama.labelItemWithHighterStock')}
                  labelRight={translate(
                    'irc.gama.labelItemWithHighterStock.unit'
                  )}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  id={'nrMinVlrStck'}
                  name={field.nrMinVlrStck}
                  labelLeft={translate('irc.gama.labelItemWithLowerValue')}
                  labelRight={translate(
                    'irc.gama.labelItemWithLowerValue.unit'
                  )}
                  inputClassName={'input size-input'}
                  type={'text'}
                />
              </Col>

              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  {...field.inTopOne.input}
                  id={'top0'}
                  name={field.inTopOne}
                  labelLeft={translate('irc.gama.labelTop0')}
                  inputClassName={'custom-input'}
                  type={'checkbox'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  {...field.inTopTwo.input}
                  id={'top1'}
                  name={field.inTopTwo}
                  labelLeft={translate('irc.gama.labelTop1')}
                  inputClassName={'custom-input'}
                  type={'checkbox'}
                />
              </Col>
              <Col xs={12} md={12} className='no-padding'>
                <LabelInputValid
                  {...field.inTopThree.input}
                  id={'top2'}
                  name={field.inTopThree}
                  labelLeft={translate('irc.gama.labelTop2')}
                  inputClassName={'custom-input'}
                  type={'checkbox'}
                />
              </Col>
              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmWtSl}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemWithSale'}
                  fieldNumber={field.nrItmWtSl}
                  idNumber={'qtdeDaysItemWithSale'}
                  label='irc.gama.labelItemsWithSale'
                  translate={translate}
                  customInputLabelWithComponent
                  customField={field.nrDayItmWtSl}
                  customFieldId={'perItemWithSale'}
                  customLabel='irc.gama.labelDays'
                  maxLength={3}
                  disabled
                />
              </Col>
              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmWtotSl}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemWithoutSale'}
                  fieldNumber={field.nrItmWtotSl}
                  idNumber={'qtdeDaysItemWithoutSale'}
                  label='irc.gama.labelItemsWithoutSale'
                  translate={translate}
                  customInputLabelWithComponent
                  customField={field.nrDayItmWtotSl}
                  customFieldId={'perItemWithoutSale'}
                  customLabel='irc.gama.labelDays'
                  maxLength={3}
                  disabled
                />
              </Col>
              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmHighRisk}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemHighRisk'}
                  fieldNumber={field.nrItmHighRisk}
                  idNumber={'perItemHighRisk'}
                  label='irc.gama.labelHighRiskProducts'
                  translate={translate}
                  maxLength={3}
                  disabled
                />
              </Col>
              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmNegStck}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemNegativeStock'}
                  fieldNumber={field.nrItmNegStck}
                  idNumber={'perItemNegativeStock'}
                  label='irc.gama.labelItemsWithNegativeStock'
                  translate={translate}
                  maxLength={3}
                  disabled
                />
              </Col>
              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmInAVs}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemInAvs'}
                  fieldNumber={field.nrItmInAvs}
                  idNumber={'perItemInAvs'}
                  label='irc.gama.labelItemsInAVS'
                  translate={translate}
                  disabled
                />
              </Col>

              <Col xs={12} md={12}>
                <EnableInput
                  fieldEnabled={field.inItmInTop2500}
                  cleanFieldNumber={this.cleanFieldNumber}
                  idEnabled={'enabledItemInTop2500'}
                  fieldNumber={field.nrItmInTop2500}
                  idNumber={'perItemInTop2500'}
                  label='irc.gama.labelItemsInTop2500'
                  translate={translate}
                  disabled
                />
              </Col>
            </Row>
          </fieldset>
          <Row className='margin-top-double margin-bottom'>
            <Col xs={8} md={6} xsOffset={2} mdOffset={3}>
              <button
                role='button'
                type='button'
                className='button button-primary button-full'
                disabled={
                  field.listRegionsAndBranchs !== undefined &&
                  field.listRegionsAndBranchs.input.value.length < 1
                }
                onClick={this.handleSubmit}
              >
                {translate('save_button_label')}
              </button>
            </Col>
          </Row>
        </form>
      </Col>
    )
  }
}

GamaForm.propTypes = {
  fields: PropTypes.object.isRequired,
  setValueToField: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
  initialValues: PropTypes.object.isRequired,
  savedGama: PropTypes.object,
  auth: PropTypes.object.isRequired,
  translate: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
  error: PropTypes.object,
  fetchSections: PropTypes.func.isRequired,
}

const fields = [
  'inItmWtSl',
  'inItmWtotSl',
  'inItmHighRisk',
  'inItmNegStck',
  'inItmInAVs',
  'nrItmWtSl',
  'nrItmWtotSl',
  'nrItmHighRisk',
  'nrItmNegStck',
  'nrItmInAvs',
  'nrDayItmWtSl',
  'nrDayItmWtotSl',
  'inTopOne',
  'inTopTwo',
  'inTopThree',
  'nrItmDaySec',
  'nrRepeatDay',
  'nrJtDiff',
  'nrJtDiffRl',
  'nrItmStckLess',
  'nrItmLrgrStck',
  'nrMinVlrStck',
  'nrItmInTop2500',
  'inItmInTop2500',
  'listRegionsAndBranchs',
]

export default Form({ fields })(GamaForm)

export { GamaForm }
